import config from 'config'

/**
 * 登录认证服务
 */
export default {
  // 当前登录用户
  currentUser: config.currentUser,

  // 是否已经登录
  isLoggedIn () {
    return this.currentUser != null
  },

  // 是否为管理员，3：平台管理员，（1，2）：用户（供应商、分销商）
  isAdmin () {
    return this.isLoggedIn() && (this.currentUser.type === 3)
  },

  // 登录
  login (redirectUrl) {
    location.assign('/user/logout?redirect=' + (redirectUrl || location.href))
  },

  // 没有权限
  noPriv () {
    location.assign('/home/no-priv')
  }
}



// WEBPACK FOOTER //
// ./src/service/authService.js